import { SwitchDispatcher } from "./Variable";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ProductType } from "../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Money } from "../../../../../../Wrap/Core/DataTypes/Money";
import { OrderType } from "../../../../../../Wrap/Constants/Enums/Domain/OrderType";

export interface SwitchableHolding {
    ProductId: number;
    ProductCode: string;
    Name: string;
    ProductType: ProductType;

    MarketValue: Money;
    CurrQuantity: number;
    OriginQuantity: number;
    SellOrders: number;
    UnitPrice?: Money;

    IsDeferred: boolean;
    HasOpenValueSellOrder: boolean;
    
    FactsheetUrl?: string;
}

export interface SwitchSellAllocation {
    ProductId: number;
    ProductCode: string;
    Name: string;
    ProductType: ProductType;

    OrderValue: number; 
    OrderPercentage: number;
    OrderQuantity: number;
    
    DisinvestAll: boolean;
    IsLimit?: boolean;
    OrderLimit?: Money;
    ExpiryDate?: Date;

    MaxSellValue?: number;
    MinSellValue?: number;
    IsValid?: boolean;
}

export interface SwitchSellTableRow {
    Instrument: {
        ProductId: number;
        DisplayName: string;
        Name: string;
        Type: ProductType;
        MarketValue: Money;
        InstrumentCode: string;
        CurrQuantity: number;
        OriginQuantity: number;
        SellOrders: number;
        UnitPrice?: Money;
        HasOpenValueSellOrder: boolean;
        IsDeferred: boolean;
    };
    OrderValue: number;
    OrderPercentage: number;
    OrderQuantity: number;
    isSellAll: boolean;
    Type: OrderType;
    InstrumentCode: string;
    tradeable: boolean;
    isLimit?: boolean;
    OrderLimit?: Money;
    ExpiryDate?: Date;
}

export interface SwitchStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class SwitchStoreStatic extends BaseStore<SwitchStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(SwitchDispatcher, (actionData) => this.onSwitchStoreResponse(actionData));
    }

    public getLastResult(): SwitchStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): SwitchStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onSwitchStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
